import * as React from 'react'
import { createContext, PropsWithChildren, ReactElement, useEffect, useState } from 'react'

export type UserContextType = {
    userId: string
    userEmail: string
    setUser: (userId: string, userEmail: string) => void
    resetUser: () => void
}

const UserContext = createContext<UserContextType>({
    userId: undefined,
    userEmail: undefined,
    setUser: undefined,
    resetUser: undefined,
})

type Props = {
    userId?: string
    userEmail?: string
}

export function UserProvider(props: PropsWithChildren<Props>): ReactElement {
    const [userId, setUserId] = useState<string>()
    const [userEmail, setUserEmail] = useState<string>()

    useEffect(() => {
        setUserId(props.userId)
    }, [props.userId])

    useEffect(() => {
        setUserEmail(props.userEmail || undefined)
    }, [props.userEmail])

    return (
        <UserContext.Provider
            value={{
                userId,
                userEmail,
                setUser: (userId: string, userEmail: string) => {
                    setUserId(userId)
                    setUserEmail(userEmail || undefined)
                },
                resetUser: () => {
                    setUserId(undefined)
                    setUserEmail(undefined)
                },
            }}
        >
            {props.children}
        </UserContext.Provider>
    )
}

export default UserContext
